export default __webpack_public_path__ + "static/g302-f0ce8bc1af3d7daf2460531e3823d3ca.jpg";